// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_o6-0";
export var buttonContainer = "_o6-3";
export var cancelButton = "_o6-4";
export var headerSection = "_o6-6";
export var headerTitle = "_o6-9";
export var messageSideLeft = "_o6-1";
export var messageSideRight = "_o6-2";
export var orderNumberContainer = "_o6-7";
export var orderNumberLabel = "_o6-8";
export var submitButton = "_o6-5";